module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/th/1/2-d183d3f0d06f416f7fa643072d601872.jpg";